const ReviewsIo = () => {
  return (
    <div></div>
  );
};

export default ReviewsIo;
